export function extractProductInfo(product: any, isPriceStrategies: boolean) {
    if (isPriceStrategies) {
        const {
            pricing_strategies: {
                mdv_prices,
                prices,
            },
            brand_name,
            display_name,
            ean_id,
            id,
            product_url,
            variant_id,
        } = product;
        const url = product.media?.[0]?.url;
        return {
            brandTitle: brand_name,
            eanId: ean_id,
            imageUrl: url,
            mdvPrices: mdv_prices,
            prices,
            productId: id,
            title: display_name,
            url: product_url,
            variantId: variant_id,
        };
    }

    const {
        listing_photo: { image_url },
        brand: { title: brandTitle },
        title,
        url,
        ean: {
            formatted_prices: { base_price, actual_price },
            is_discounted,
            optin_discount_value,
            ean_id,
            variant_id,
        },
        product_id,
    } = product;

    return {
        actualPrice: actual_price,
        basePrice: base_price,
        brandTitle,
        eanId: ean_id,
        imageUrl: image_url,
        isDiscounted: is_discounted,
        optinDiscountValue: optin_discount_value,
        productId: product_id,
        title,
        url,
        variantId: variant_id,
    };
}
